import { useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";

import { AuthProvider } from "@/lib/AuthContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import ConsultationDialog from "@/components/ConsultationDialog";
import ProtectedRoute from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Projects from "@/pages/Projects";
import Contact from "@/pages/Contact";
import Invest from "@/pages/Invest";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function PublicChrome({ children, onOpenConsult }) {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <>
      {!isAdmin && <Navbar onOpenConsult={onOpenConsult} />}
      <main>{children}</main>
      {!isAdmin && <Footer onOpenConsult={onOpenConsult} />}
    </>
  );
}

function App() {
  const [consultOpen, setConsultOpen] = useState(false);
  const openConsult = () => setConsultOpen(true);
  const closeConsult = () => setConsultOpen(false);

  return (
    <div className="App" data-testid="app-root">
      <BrowserRouter>
        <AuthProvider>
          <ScrollToTop />
          <PublicChrome onOpenConsult={openConsult}>
            <Routes>
              <Route path="/" element={<Home onOpenConsult={openConsult} />} />
              <Route path="/about" element={<About onOpenConsult={openConsult} />} />
              <Route path="/services" element={<Services onOpenConsult={openConsult} />} />
              <Route path="/projects" element={<Projects onOpenConsult={openConsult} />} />
              <Route path="/invest" element={<Invest />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminDashboard />
                  </ProtectedRoute>
                }
              />
              <Route path="*" element={<Home onOpenConsult={openConsult} />} />
            </Routes>
          </PublicChrome>
          <ConsultationDialog open={consultOpen} onClose={closeConsult} />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
